<template>
  <f7-page ref="page" id="asset-info-page" name="asset-info">
    <f7-block>
      <div class="card p-p-3 p-d-flex">
        <f7-link href="/dashboard/">
          <f7-icon icon="f7-icons icon-back custom-color"></f7-icon>
        </f7-link>

        <span v-if="asset" class="p-px-4 custom-color">{{ asset.Name }}</span>
        <span v-else class="p-px-4 custom-color">Loading...</span>
      </div>
    </f7-block>

    <f7-block class="left-panel p-mt-0">
      <Card>
        <template #title> Position Details</template>
        <template #content>
          <DataView :value="details" layout="list">
            <template #list="slotProps">
              <div
                v-for="(item, index) in slotProps.items"
                :key="index"
                class="list-item"
              >
                <div class="container-icon p-pr-3">
                  <f7-icon
                    :icon="`icon-` + item.icon + ` f7-icons size-20`"
                  ></f7-icon>
                </div>
                <div class="container-text">
                  <span class="label">{{ item.label }}</span>
                  <span class="value" v-if="item.type !== 'playback'">{{
                    item.value
                  }}</span>

                  <!-- Playback Speed (Кнопка Play + ПрогрессБар) -->
                  <div
                    v-if="item.type === 'playback'"
                    class="container-playback"
                  >
                    <Button
                      :icon="isPlaying ? 'pi pi-pause' : 'pi pi-play'"
                      class="p-button-rounded p-button-success play-button"
                      @click="togglePlayback"
                    />
                    <Slider
                      v-model="progress"
                      :min="0"
                      :max="100"
                      class="progress-bar"
                    />
                  </div>
                </div>
              </div>
            </template>
          </DataView>
        </template>
      </Card>
    </f7-block>
    <l-map
      ref="mapRef"
      @ready="isReady"
      :useGlobalLeaflet="true"
      :use-global-leaflet="true"
      :zoom="zoom"
      :center="center"
      :options="{ zoomControl: false, preferCanvas: true }"
      class="map-wrapper"
    >
      <l-tile-layer
        v-for="tileProvider in layersToShow"
        :key="tileProvider.name"
        :url="tileProvider.url"
        :subdomains="tileProvider.subdomains"
      />

      <l-layer-group v-if="mapOverlays.length">
        <l-tile-layer
          v-for="overlay in mapOverlays"
          :key="overlay.name"
          :url="overlay.url"
        />
      </l-layer-group>
    </l-map>
    <div v-if="isLoading" class="overlay">
      <ProgressSpinner />
    </div>
  </f7-page>
</template>

<script>
import { useI18n } from "vue-i18n";
import { useStore, mapGetters } from "vuex";
import { f7, f7router } from "framework7-vue";
import { ref } from "vue";
import DataView from "primevue/dataview";
import Card from "primevue/card";
import Button from "primevue/button";
import ProgressSpinner from "primevue/progressspinner";

import {
  getFromStorage,
  setInStorage,
  isObjEmpty,
  Protocol,
  getFormDataFromObject,
  parsePlaybackHystoryArr,
  getPlaybackFilterHistoryList,
} from "../js/helper";
import moment from "moment-mini";
import L from "leaflet";
import "leaflet.markercluster";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.featuregroup.subgroup";
import Slider from "primevue/slider";
import APIMETHODS from "../js/api-methods";
import axios from "axios";
import VueGauge from "vue-gauge";
import {
  LMap,
  LIcon,
  LTileLayer,
  LMarker,
  LControlLayers,
  LPopup,
  LLayerGroup,
} from "@vue-leaflet/vue-leaflet";
import store from "../store/store";

export default {
  name: "asset-playback",
  components: {
    LMap,
    LIcon,
    LTileLayer,
    LMarker,
    LLayerGroup,
    LControlLayers,
    LPopup,
    Button,
    DataView,
    Card,
    Slider,
    ProgressSpinner,
    VueGauge,
  },

  props: {
    from: String,
    to: String,
    imei: String,
  },

  directives: {
    // tooltip: Tooltip
  },

  data() {
    const { t } = useI18n();
    return {
      isLoading: false,
      zoom: 2,
      center: [9.675228, -171.364896],
      layersToShow: [],
      mapOverlays: [],
      asset: null,
      PlaybackFrom: null,
      PlaybackTo: null,
      IMEI: null,
      isIgnore: true,
      mapRef: ref(),
      TripsDirectionIcons: {},
      TripsRoutes: [],
      TripsRoutesOptimized: {},
      PlaybackRouteLayerGroup: false,
      PlaybackRouteLayerGroupOptimized: false,
      PlaybackMarkerGroup: false,
      PlaybackMarker: false,
      PlaybackEventsLayerGroup: false,
      PlaybackHistoryLayerGroup: false,
      PlaybackEventsLayerSubGroups: {},
      PlaybackHistoryLayerSubGroups: {},
      isDirectionIconsOnMap: true,
      // PlaybackFilterEventsList: playbackFilterEventsList,
      PlaybackFilterHistoryList: getPlaybackFilterHistoryList(),
      TripCustomization: {
        colors: [
          "#4dc08e",
          "#f96868",
          "#f9b256",
          "#00b9ee",
          "#5972b6",
          "#c693c2",
          "#f28d4f",
          "#303030",
          "#009a93",
          "#857c13",
          "#ff59ac",
          "#ff5975",
          "#004899",
          "#7a0727",
          "#9185be",
        ],
        colorNames: [
          "color-1",
          "color-2",
          "color-3",
          "color-4",
          "color-5",
          "color-6",
          "color-7",
          "color-8",
          "color-9",
          "color-10",
          "color-11",
          "color-12",
          "color-13",
          "color-14",
          "color-15",
        ],
      },
      PolylineCustomizationSemi: {
        mainBg: {
          //color: '#f44336',
          color: "#039ac5",
          weight: 6,
          opacity: 0.8,
        },
        main: {
          //color: '#f96868',
          color: "#00b9ee",
          weight: 3,
          opacity: 0.8,
        },
        droppedBg: {
          //color: '#b50000',     //red
          color: "#b47605", //orange
          weight: 6,
          opacity: 0.8,
        },
        dropped: {
          //color: '#fc0405',
          color: "#fd9a08", //orange
          weight: 3,
          opacity: 0.8,
        },
        boundariesBg: {
          color: "#6199CC",
          weight: 6,
          opacity: 0.8,
        },
        boundaries: {
          color: "#00B1FC",
          weight: 3,
          opacity: 0.8,
        },
      },
      details: [
        { icon: "playback", label: "Playback Speed", value: "x1" },
        {
          icon: "date",
          label: "Date, Time",
          value: "2025-02-10 19:59:58",
        },
        { icon: "speed", label: "Speed", value: "12 km/h" },
        {
          icon: "coordinates",
          label: "Direction",
          value: "Northwest (328°)",
        },
        { icon: "mileage", label: "Mileage", value: "205563 km" },
        {
          icon: "location",
          label: "Location",
          value:
            "Marshall Road, Malaga, City of Swan, Western Australia, 6090, Australia",
        },
      ],
    };
  },

  computed: {
    ...mapGetters(["MajorToken", "MinorToken"]),
  },

  created() {},

  async mounted() {
    var self = this;
    self.initializeMapLayers();

    let userInfo = getFromStorage("userInfo");
    let assetList = getFromStorage("assetList");

    self.PlaybackFrom = self.from;
    self.PlaybackTo = self.to;
    self.IMEI = self.imei;
    self.asset = assetList.find((item) => item.IMEI === self.imei);

    if (this.timeZone) {
      let offset = this.timeZone.split("_")[0];
      this.OffsetHours = parseFloat(offset);
    }

    console.log("this.$COM_TIMEFORMAT2", this.$COM_TIMEFORMAT2);

    let query = {
      MajorToken: userInfo.MajorToken,
      MinorToken: userInfo.MinorToken,
      DateFrom: moment
        .utc(self.PlaybackFrom, this.$COM_TIMEFORMAT2)
        .add(self.OffsetHours, "hours")
        .format(this.$COM_TIMEFORMAT),
      DateTo: moment
        .utc(self.PlaybackTo, this.$COM_TIMEFORMAT2)
        .add(self.OffsetHours, "hours")
        .format(this.$COM_TIMEFORMAT),
      Imeis: [self.IMEI],
    };

    try {
      //let data = getFormDataFromObject(query)
      this.isLoading = true;
      let data = new URLSearchParams(query).toString();
      let response = await fetch(APIMETHODS.GET_REPORT_TRIP, {
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Referer: "https://cartrack.co/",
        },
      });

      response = await response.json();
      //console.log(response)

      if (response.MajorCode === "000") {
        console.log(
          "response.Data && response.Data.length",
          response.Data && response.Data.length
        );

        if (response.Data && response.Data.length) {
          console.log("response.Data[0].Details", response.Data[0].Details);
          self.initTripList(response.Data[0].Details);
        } else {
          console.log("getTrips2");

          self.getTrips2();
        }
      } else {
        self.errorMessage = `<br>MajorCode: ${response.MajorCode}<br>MinorCode: ${response.MinorCode}<br>${response.Data}`;
        response.errorDialogVisible = true;
      }
    } catch (e) {
      self.errorMessage = "Error occurred while getting Trips data";
      self.errorDialogVisible = true;
    }

    //console.log(this.asset);

    let historyArray = getFromStorage("historyArray");

    // var playbackControllButton = page.$el.find('.playback-controll-button');
    // var playbackControllButtonIcon = page.$el.find('.playback-controll-button i');
    // var playbackSpeed = page.$el.find('[name="PlaybackSpeed"]');
    // var rangeSliderEl = page.$el.find('.range-slider-playback');
    // var optimizedSwitcher = page.$el.find('input[name="checkbox-optimized"]');

    var lastQueryPosinfo = {};
    self.showPlaybackRoute();
  },

  unmounted() {},
  methods: {
    isReady() {
      if (this.$refs.mapRef) {
        console.log(this.$refs.mapRef.leafletObject);
      }
    },
    showPlaybackRoute: function () {
      var self = this;

      let MapTrack = this.$refs.mapRef.leafletObject;

      if (self.PlaybackRouteLayerGroup && self.PlaybackMarkerGroup) {
        if (self.OptimizedRouteState && self.PlaybackRouteLayerGroupOptimized) {
          MapTrack.addLayer(self.PlaybackRouteLayerGroupOptimized);
          MapTrack.fitBounds(self.PlaybackRouteLayerGroupOptimized.getBounds());
        } else {
          MapTrack.addLayer(self.PlaybackRouteLayerGroup);
          MapTrack.fitBounds(self.PlaybackRouteLayerGroup.getBounds());
        }

        MapTrack.addLayer(self.PlaybackMarkerGroup);
        MapTrack.addLayer(self.PlaybackEventsLayerGroup);
      } else {
        /*PLAYBACK ROUTE ADDING*/
        var historyArray = getFromStorage("historyArray") || [];
historyArray = historyArray.filter(value => value && !isNaN(parseFloat(value.lat)) && !isNaN(parseFloat(value.lng)));

        var polylinePoints = [];

        $.each(historyArray, function (index, value) {
          if (
            !value.lat ||
            !value.lng ||
            isNaN(value.lat) ||
            isNaN(value.lng)
          ) {
            console.error(`Skipping invalid point at index ${index}:`, value);
            return;
          }
         

          if (!value || isNaN(parseFloat(value.lat)) || isNaN(parseFloat(value.lng))) {
    console.error(`Skipping invalid point at index ${index}:`, value);
    return;
}
var point = new L.LatLng(parseFloat(value.lat), parseFloat(value.lng));
 

          polylinePoints.push(point);
        });

        var polylineBG = new L.Polyline(
          polylinePoints,
          self.PolylineCustomizationSemi.mainBg
        );
        var polyline = new L.Polyline(
          polylinePoints,
          self.PolylineCustomizationSemi.main
        );
        self.PlaybackRouteLayerGroup = L.featureGroup([polylineBG, polyline]);
        self.PlaybackRouteLayerGroup.addTo(MapTrack);

        this.isLoading = false;

        // if (self.isLife || self.isQProtect) {
        //   polylineBG.options.opacity = 0
        //   polyline.options.opacity = 0
        // }

       // MapTrack.fitBounds(polyline.getBounds()); // zoom the map to the polyline

       console.log("polylinePoints:", polylinePoints);

       if (!polylinePoints.length) {
    console.error("No valid polyline points, skipping polyline creation.");
    return;
}

       polylinePoints.forEach((p, i) => {
            if (isNaN(p.lat) || isNaN(p.lng)) {
                console.error(`Invalid point detected at index ${i}:`, p);
            }
        });

        if (polylinePoints.length < 2) {
    console.warn("Not enough valid points for fitBounds:", polylinePoints);
} else if (new Set(polylinePoints.map(p => `${p.lat},${p.lng}`)).size === 1) {
    console.warn("All points in polyline are identical. Using setView instead.");
    MapTrack.setView(polylinePoints[0], 15);  
} else {
    MapTrack.fitBounds(polyline.getBounds());
}


        /*EVENTS POINTS ADDING*/

        var historyEvents = getFromStorage("historyEvents");

        if (historyArray && historyArray.length) {
          self.PlaybackHistoryLayerGroup = L.markerClusterGroup({
            maxClusterRadius: 35,
            spiderfyOnMaxZoom: false,
            showCoverageOnHover: false,
            zoomToBoundsOnClick: false,
          });

          var markerData = "";
          let point = "";
          var popupAddresses = {};
          let newHistoryArr = [];
          let pinDetails = {};
          let rotDeg = 0;
          let playbackHistoryGroups = {};

          //console.log(self.PlaybackHistoryLayerGroup, 'self.PlaybackHistoryLayerGroup')

          for (var i = self.PlaybackFilterHistoryList.length - 1; i >= 0; i--) {
            self.PlaybackHistoryLayerSubGroups[
              self.PlaybackFilterHistoryList[i].Value
            ] = L.featureGroup
              .subGroup(self.PlaybackHistoryLayerGroup)
              .addTo(MapTrack);
          }
          // console.log(POSINFOASSETLIST[self.$route.params.imei].posInfo)
          $.each(historyArray, function (index, value) {
            //console.log('HIS:', value)
            if (!value.lat || !value.lng || isNaN(value.lat) || isNaN(value.lng)) {
              console.error(`Skipping invalid point at index ${index}:`, value);
              return;
            }
                      pinDetails = self.getPlaybackMapHisPinDetails(value);
            value.index = index;
            value.pclass = POSINFOASSETLIST[self.IMEI].posInfo.protocolClass;
            value.PRDTFeatures = POSINFOASSETLIST[self.IMEI]?.PRDTFeatures;
            value.defVol =
              +POSINFOASSETLIST[self.IMEI].posInfo?.Voltage +
              0.5 -
              Math.random();
            value.defBat =
              +POSINFOASSETLIST[self.IMEI].posInfo?.Battery +
              0.5 -
              Math.random();

            if (value.status == 2097157) {
              rotDeg = +value.direct;
            }

            markerData = self.$app.methods.getPlaybackMarkerDataTableInfoPin(
              value,
              { GeofenceList: self.GeofenceList },
              true
            );
            if (!value || isNaN(parseFloat(value.lat)) || isNaN(parseFloat(value.lng))) {
                console.error(`Skipping invalid marker at index ${index}:`, value);
                return;
            }

            point = L.marker([parseFloat(value.lat), parseFloat(value.lng)], {
                icon: pinDetails.Icon,
                customPlaybackFilterType: pinDetails.CustomFilterType,
                rotationAngle: rotDeg
            });

            point
              .bindPopup(markerData, {
                maxWidth: self.$app.data.MaxMapPopupWidth,
                closeButton: false,
              })
              .on("popupopen", function (marker) {
                if (popupAddresses[index]) {
                  $$("body #map")
                    .find('[data-popupIdAddress="' + index + '"]')
                    .html(popupAddresses[index]);
                } else {
                  Protocol.Helper.getAddressByGeocoder(
                    this.getLatLng(),
                    function (address) {
                      $$("body #map")
                        .find('[data-popupIdAddress="' + index + '"]')
                        .html(address);
                      popupAddresses[index] = address;
                    }
                  );
                }
              });

            newHistoryArr.push(self.formatHistoryData(value));

            self.PlaybackHistoryLayerSubGroups[
              pinDetails.CustomFilterType
            ].addLayer(point);
            value.MarkerId =
              self.PlaybackHistoryLayerSubGroups[
                pinDetails.CustomFilterType
              ].getLayerId(point);
          });

          //var gpxString = L.ConvertCoords.GPX.convert(self.PlaybackHistoryLayerGroup);
          //console.log('gpxString',gpxString)

          MapTrack.addLayer(self.PlaybackHistoryLayerGroup);
          // self.$setState({
          //   HistoryList: newHistoryArr
          // })

          //  console.log('newHistoryArr', newHistoryArr)

          // self.$setState({

          //   isHistoryAddressesLoaded: true
          // });
          self.PlaybackHistoryLayerGroup.on("clusterclick", function (a) {
            let zoom = MapTrack.getZoom();

            if (zoom < 15) {
              // MapTrack.setView(a.layer.getLatLng(),15)
            }
            a.layer.spiderfy();
          });
          // let promise = new Promise(function(resolve, reject) {
          //   self.getAddresses(newHistoryArrLatLngs, resolve, reject);
          // });
          // self.$setState({
          //   isHistoryAddressesLoaded: false
          // })
          // promise.then(function(result) {
          //   //console.log(result);
          //   if (result && result.length) {
          //     for (var i = result.length - 1; i >= 0; i--) {
          //       if (result[i] && typeof result[i] === 'object' && result[i].display_name) {
          //         self.HistoryList[i].CustomAddress = result[i].display_name;
          //       }

          //     }
          //     self.$setState({
          //       HistoryList: self.HistoryList,
          //       isHistoryAddressesLoaded: true
          //     });
          //   }
          // }, function(error){
          //   console.log(error);
          // });
        }

        if (historyEvents && historyEvents.length) {
          self.PlaybackEventsLayerGroup = L.markerClusterGroup({
            maxClusterRadius: 35,
          });
          var markerData = "";
          let point = "";
          var popupAddresses = {};
          let newEventsArr = [];
          let newEventsArrLatLngs = [];
          let pinDetails = {};
          //let playbackEventsGroups = {};
          for (var i = self.PlaybackFilterEventsList.length - 1; i >= 0; i--) {
            self.PlaybackEventsLayerSubGroups[
              self.PlaybackFilterEventsList[i].Value
            ] = L.featureGroup
              .subGroup(self.PlaybackEventsLayerGroup)
              .addTo(MapTrack);
          }

          $.each(historyEvents, function (index, value) {
            //console.log('EV:', value)
            if (parseFloat(value.lat) !== 0 && parseFloat(value.lng) !== 0) {
              if (
                value.eventClass == 1 ||
                (value.eventClass == 2 && value.eventType == 1) ||
                (value.eventClass == 4 && value.eventType == 0)
              ) {
                //filtering to display only   1-Alert(alarms) , 2-ACC , 4 - static  events
                pinDetails = self.getPlaybackMapPinDetails(value);
                value.index = index;
                value.pclass =
                  POSINFOASSETLIST[self.IMEI].posInfo.protocolClass;
                value.PRDTFeatures = POSINFOASSETLIST[self.IMEI]?.PRDTFeatures;
                value.defVol =
                  +POSINFOASSETLIST[self.IMEI].posInfo?.Voltage +
                  0.5 -
                  Math.random();
                value.defBat =
                  +POSINFOASSETLIST[self.IMEI].posInfo?.Battery +
                  0.5 -
                  Math.random();
                markerData =
                  self.$app.methods.getPlaybackMarkerDataTableInfoPin(value, {
                    GeofenceList: self.GeofenceList,
                  });
                point = L.marker([value.lat, value.lng], {
                  icon: pinDetails.Icon,
                  customPlaybackFilterType: pinDetails.CustomFilterType,
                });
                point
                  .bindPopup(markerData, {
                    maxWidth: self.$app.data.MaxMapPopupWidth,
                    closeButton: false,
                  })
                  .on("popupopen", function (marker) {
                    if (popupAddresses[index]) {
                      $$("body #map")
                        .find('[data-popupIdAddress="' + index + '"]')
                        .html(popupAddresses[index]);
                    } else {
                      Protocol.Helper.getAddressByGeocoder(
                        this.getLatLng(),
                        function (address) {
                          $$("body #map")
                            .find('[data-popupIdAddress="' + index + '"]')
                            .html(address);
                          popupAddresses[index] = address;
                        }
                      );
                    }
                  });

                //self.PlaybackEventsLayerArr.push(point);

                //self.PlaybackEventsLayerGroup.addLayer(point);
                //console.log(pinDetails.CustomFilterType);
                self.PlaybackEventsLayerSubGroups[
                  pinDetails.CustomFilterType
                ].addLayer(point);
                value.MarkerId =
                  self.PlaybackEventsLayerSubGroups[
                    pinDetails.CustomFilterType
                  ].getLayerId(point);

                newEventsArr.push(self.formatEventData(value));
                newEventsArrLatLngs.push([value.lat, value.lng]);
              }
            }
          });

          /*self.PlaybackEventsLayerGroup.eachLayer(function(layer){
              console.log(layer)
          });*/
          MapTrack.addLayer(self.PlaybackEventsLayerGroup);

          self.$setState({
            EventsList: newEventsArr,
          });

          self.PlaybackEventsLayerGroup.on("clusterclick", function (a) {
            //MapTrack.setView(a.layer.getLatLng(),15)
          });
          // let promise = new Promise(function(resolve, reject) {
          //   self.getAddresses(newEventsArrLatLngs, resolve, reject);
          // });
          // self.$setState({
          //   isActivityAddressesLoaded: false
          // })
          // promise.then(function(result) {
          //   //console.log(result);
          //   if (result && result.length) {
          //     for (var i = result.length - 1; i >= 0; i--) {
          //       if (result[i]) {
          //         self.EventsList[i].CustomAddress = result[i];
          //       }

          //     }
          //     self.$setState({
          //       EventsList: self.EventsList,
          //       isActivityAddressesLoaded: true
          //     });
          //   }
          // }, function(error){
          //   console.log(error);
          // });
        }

        /*MARKER ADDING*/
        self.PlaybackMarkerGroup = L.markerClusterGroup({
          maxClusterRadius: 35,
        });
        if (
          historyArray.length > 0 &&
          !isNaN(historyArray[0].lat) &&
          !isNaN(historyArray[0].lng)
        ) {
          self.PlaybackMarker = L.marker(
            [historyArray[0].lat, historyArray[0].lng],
            {
              icon: !self.$app.data.AppDetails.customMapMarker
                ? Protocol.MarkerIcon[2]
                : self.$app.data.AppDetails.customMapMarker,
            }
          );
        } else {
          console.error("Invalid first history point:", historyArray[0]);
        }
        self.PlaybackMarker.bindTooltip(self.Name, {
          permanent: false,
          direction: "right",
        });
        self.PlaybackMarker.addTo(self.PlaybackMarkerGroup);
        self.PlaybackMarkerGroup.addTo(MapTrack);
      }
    },
    getTrips: function () {
      console.log("this.$COM_TIMEFORMAT2", this.$COM_TIMEFORMAT2);

      let self = this;

      self.$app.request.post(
        API_URL.GET_REPORT_TRIP,
        data,
        function (result, xhr, status) {
          if (result.MajorCode === "000") {
            console.log(
              "result.Data && result.Data.length",
              result.Data && result.Data.length
            );
            if (result.Data && result.Data.length) {
              //self.initSummaryList(result.Data[0].Total, result.Data[0].Details);
              self.initTripList(result.Data[0].Details);
            } else {
              //self.initSummaryList();
              //~~~self.initTripList();
              self.getTrips2();
            }
          } else {
            self.$app.dialog.alert(
              LANGUAGE.PROMPT_MSG023 +
                `<br>MajorCode: ${result.MajorCode}<br>MinorCode: ${result.MinorCode}<br>${result.Data}`
            );
          }
        },
        function (xhr, status) {
          self.$app.dialog.close();
          self.$app.dialog.alert("Error occured at get Trips data");
        },
        "json"
      );
    },
    getTrips2: function () {
      let self = this;
      let userInfo = self.$app.methods.getFromStorage("userInfo");
      let data = {
        MajorToken: userInfo.MajorToken,
        MinorToken: userInfo.MinorToken,
        DateFrom: moment
          .utc(self.PlaybackFrom, this.$COM_TIMEFORMAT2)
          .add(self.OffsetHours, "hours")
          .format(this.$COM_TIMEFORMAT),
        DateTo: moment
          .utc(self.PlaybackTo, this.$COM_TIMEFORMAT2)
          .add(self.OffsetHours, "hours")
          .format(this.$COM_TIMEFORMAT),
        Imeis: [self.IMEI],
      };

      console.log("GET_REPORT_TRIP2");
      self.$app.request.post(
        API_URL.GET_REPORT_TRIP2,
        data,
        function (result, xhr, status) {
          if (result.MajorCode === "000") {
            if (result.Data && result.Data.length) {
              console.log("result.Data.length", result.Data.length);
              //self.initSummaryList(result.Data[0].Total, result.Data[0].Details);
              self.initTripList(result.Data[0].Details);
            } else {
              console.log("getTrips3");
              //self.initSummaryList();
              self.initTripList();
            }
          } else {
            self.$app.dialog.alert(
              LANGUAGE.PROMPT_MSG023 +
                `<br>MajorCode: ${result.MajorCode}<br>MinorCode: ${result.MinorCode}<br>${result.Data}`
            );
          }
        },
        function (xhr, status) {
          self.$app.dialog.close();
          self.$app.dialog.alert("Error occured at get Trips data");
        },
        "json"
      );
    },
    initTripList: function (tripsDetails = []) {
      let self = this;

      if (tripsDetails && tripsDetails.length) {
        let startLatLngs = [];
        let endLatLngs = [];
        let colorLoopIndex = 0;
        let userInfo = getFromStorage("userInfo");
        let modifiedTripDetails = [];

        tripsDetails.forEach((trip) => {
          //console.log('trip', trip)
          if (trip.StartTime) {
            trip.StartTimeLocal = moment(trip.StartTime, this.$COM_TIMEFORMAT3)
              .add(moment().utcOffset(), "minutes")
              .format(this.$COM_TIMEFORMAT);
            trip.StartTimeLocalDate = moment(
              trip.StartTimeLocal,
              this.$COM_TIMEFORMAT
            ).format(this.$COM_TIMEFORMAT4);
          }
          if (trip.EndTime) {
            trip.EndTimeLocal = moment(trip.EndTime, this.$COM_TIMEFORMAT3)
              .add(moment().utcOffset(), "minutes")
              .format(this.$COM_TIMEFORMAT);
          }
          trip.color = self.TripCustomization.colorNames[colorLoopIndex];
          trip.colorHEX = self.TripCustomization.colors[colorLoopIndex];

          startLatLngs.push([trip.StartLat, trip.StartLng]);
          endLatLngs.push([trip.EndLat, trip.EndLng]);

          if (
            !modifiedTripDetails.length ||
            modifiedTripDetails[modifiedTripDetails.length - 1]
              .StartTimeLocalDate !== trip.StartTimeLocalDate
          ) {
            modifiedTripDetails.push({
              Divider: true,
              StartTimeLocalDate: trip.StartTimeLocalDate,
            });
          }
          modifiedTripDetails.push(trip);
          colorLoopIndex = colorLoopIndex === 14 ? 0 : ++colorLoopIndex;
        });

        let promiseStartAddress = new Promise(function (resolve, reject) {
          self.getAddresses(startLatLngs, resolve, reject);
        });
        let promiseEndAddress = new Promise(function (resolve, reject) {
          self.getAddresses(endLatLngs, resolve, reject);
        });

        Promise.all([
          promiseStartAddress.catch((error) => {
            return error;
          }),
          promiseEndAddress.catch((error) => {
            return error;
          }),
        ])
          .then((values) => {
            if (values[0] && values[1]) {
              //for index shifting, which is needed to ignore item divider in trip list and insert correct value of address
              let shift = 0;
              for (let i = 0; i < modifiedTripDetails.length; i++) {
                if (modifiedTripDetails[i].Divider) {
                  shift = shift - 1;
                } else {
                  if (values[0][i + shift]) {
                    modifiedTripDetails[i].StartCustomAddress =
                      values[0][i + shift];
                  }
                  if (values[1][i + shift]) {
                    modifiedTripDetails[i].EndCustomAddress =
                      values[1][i + shift];
                  }
                }
              }

              self.TripList = modifiedTripDetails;
            }
          })
          .catch((error) => {
            console.log(error);
          });

        for (let [tripIndex, trip] of modifiedTripDetails.entries()) {
          this.getTripRoute({
            MinorToken: userInfo.MinorToken,
            IsIgnore: self.isIgnore,
            Code: self.asset.Id,
            From: moment(trip.StartTime, this.$COM_TIMEFORMAT3).format(
              this.$COM_TIMEFORMAT2
            ),
            To: moment(trip.EndTime, this.$COM_TIMEFORMAT3).format(
              this.$COM_TIMEFORMAT2
            ),
          })
            .then((result) => {
              console.log("result", result);
              let polylinePoints = [];
              let prevPoint = {};
              self.TripsDirectionIcons[tripIndex] = L.featureGroup();

              let MapTrack = this.$refs.mapRef.leafletObject;

              $.each(result, function (index, value) {
                console.log("value", value);
                let point = new L.LatLng(value.lat, value.lng);
                polylinePoints.push(point);
                console.log("point", point);
                //for small optimisation
                let temp = {
                  lat: Math.floor(value.lat * 10000) / 10000,
                  lng: Math.floor(value.lng * 10000) / 10000,
                };
                if (
                  index !== 0 &&
                  temp.lat !== prevPoint.lat &&
                  temp.lng !== prevPoint.lng
                ) {
                  prevPoint = Object.assign({}, temp);
                  L.canvasMarker(point, {
                    radius: 10,
                    prevLatlng:
                      index === 0
                        ? false
                        : L.latLng(
                            result[index - 1].lat,
                            result[index - 1].lng
                          ), //previous point
                    img: {
                      url: "resources/images/direction-arrow.svg",
                      size: [20, 20],
                      rotate: 0,
                    },
                  }).addTo(self.TripsDirectionIcons[tripIndex]);
                }
              });

              let polylineBG = new L.Polyline(polylinePoints, {
                color: trip.colorHEX,
                weight: 6,
                opacity: 0.9,
              });
              let polyline = new L.Polyline(polylinePoints, {
                color: trip.colorHEX,
                weight: 3,
                opacity: 0.9,
              });
              if (self.isLife || self.isQProtect) {
                polylineBG.options.opacity = 0;
                polyline.options.opacity = 0;
              }
              console.log("trip", trip);
              console.log("polylineBG", polylineBG);

              if (polylineBG && polyline) {
                self.TripsRoutes[tripIndex] = L.featureGroup([
                  polylineBG,
                  polyline,
                ]);
              } else {
                console.error("One of the polylines is undefined:", {
                  polylineBG,
                  polyline,
                });
              }

              if (self.isDirectionIconsOnMap) {
                //self.TripsDirectionIcons[tripIndex].addTo(MapTrack);
                console.log(
                  "self.TripsRoutes[tripIndex]",
                  self.TripsRoutes[tripIndex]
                );
                console.log(
                  "this.TripsDirectionIcons[tripIndex]",
                  this.TripsDirectionIcons[tripIndex]
                );
                this.TripsRoutes[tripIndex].addTo(MapTrack);
                this.TripsDirectionIcons[tripIndex].addTo(MapTrack);
              }

              // if (!self.OptimizedRouteState) {
              //   self.TripsRoutes[tripIndex].addTo(MapTrack);
              // }

              return result;
            })
            //.then((result) => this.getTripRouteOptimized(result))
            .then((result) => {
              if (isObjEmpty(result)) {
                return;
              }

              let polylines = [];
              if (result.polylines && result.polylines.length) {
                polylines = polylines.concat(result.polylines);
              }
              if (result.dropped && result.dropped.length) {
                polylines = polylines.concat(result.dropped);
              }
              if (result.boundaries && result.boundaries.length) {
                polylines = polylines.concat(result.boundaries);
              }

              let polylineOptBg = new L.Polyline(polylines, {
                color: trip.colorHEX,
                weight: 6,
                opacity: 0.7,
              });
              let polylineOpt = new L.Polyline(polylines, {
                color: trip.colorHEX,
                weight: 3,
                opacity: 0.7,
              });
              // if (self.isLife || self.isQProtect) {
              //   polylineOptBg.options.opacity = 0;
              //   polylineOpt.options.opacity = 0;
              // }

              self.TripsRoutesOptimized[tripIndex] = L.featureGroup([
                polylineOptBg,
                polylineOpt,
              ]);
              if (self.OptimizedRouteState) {
                self.TripsRoutesOptimized[tripIndex].addTo(MapTrack);
              }
            });
        }
      }
      //console.log('here')
      self.$setState({
        isTripsLoaded: true,
        TripList: tripsDetails,
      });
    },
    initializeMapLayers() {
      const lang = "en";
      const mapSettingsObg = this.getMapSettings();

      const osm = {
        name: "osm",
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      };
      const googleStreets = {
        name: "google",
        url: `https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&hl=${lang}`,
        subdomains: ["mt0", "mt1", "mt2", "mt3"],
      };
      const googleSatelitte = {
        name: "satellite",
        url: `https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}&hl=${lang}`,
        subdomains: ["mt0", "mt1", "mt2", "mt3"],
      };

      const layerSeaMark = {
        name: "seamark",
        url: "https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png",
      };

      if (mapSettingsObg.map === "google")
        this.layersToShow.push(googleStreets);
      if (mapSettingsObg.map === "satellite")
        this.layersToShow.push(googleSatelitte);
      if (mapSettingsObg.map === "openstreet") this.layersToShow.push(osm);

      if (!this.layersToShow.length) this.layersToShow.push(googleStreets);

      if (mapSettingsObg.seamark) this.mapOverlays.push(layerSeaMark);
    },

    getMapSettings() {
      return {
        map: "google",
        seamark: true,
      };
    },
    async getAddresses(arr, resolve, reject) {
      let data = {
        coordinates: arr,
      };
      try {
        let response = await fetch(APIMETHODS.GET_ADDRESSES_FROM_ARRAY, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        let result = await response.json();
        resolve(result);
      } catch (xhr) {
        console.error(xhr);
        reject(xhr);
      }
    },

    async getTripRoute(params) {
      try {
        /// TypeError: Failed to execute 'fetch' on 'Window': Request with GET/HEAD method cannot have body.

        let result = await this.$store.dispatch("GET_PLAYBACK_ARR", params);

        //console.log('result', result)
        //let result = await response.json();
        //this.$app.dialog.close();

        if (result.MajorCode === "000" && result.Data) {
          let HistoryArray = parsePlaybackHystoryArr(result.Data.HisArry);

          console.log("HistoryArray", HistoryArray);
          this.HistoryArray = HistoryArray;

          return HistoryArray;
        } else {
          return [];
        }
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    getTripRouteOptimized(historyArray) {
      var self = this;
      return new Promise((resolve, reject) => {
        var rawArray = [];
        $.each(historyArray, function (index, value) {
          console.log('value', value);
                  if (!value.lat || !value.lng || isNaN(value.lat) || isNaN(value.lng)) {
            console.error(`Skipping invalid point at index ${index}:`, value);
            return;
          }
          rawArray.push([
            null,
            null,
            null,
            new Date(value.positionTime * 1000),
            null,
            null,
            null,
            null,
            null,
            null,
            value.lat, //lat
            value.lng, // lng
            null,
            value.direct, //direct
            value.speed, //speed
            value.mileage, //mileage
          ]);
        });
        if (!rawArray.length) {
          resolve({});
          return;
        }
        $.ajax({
          type: "POST",
          url: APIMETHODS.GET_PLAYBACK_ARR_OPTIMISED2, //API_URL.GET_PLAYBACK_ARR_WITHOUTADDRESSES_OPTIMISED,
          dataType: "json",
          data: JSON.stringify(rawArray),
          contentType: "application/json",
          async: true,
          cache: false,
          timeout: 10000,
          success: function (result) {
            //console.log(result);
            resolve(result);
          },
          error: function (textStatus) {
            resolve({});
            //self.$setState({ OptimizedRouteState: false, CantBeOptimised: true });
          },
        });
      });
    },
    getPlaybackMapHisPinDetails: function (point = {}) {
      let ret = {
        Icon: Protocol.MarkerIcon[3],
        CustomFilterType: "2",
      };
      switch (point.status) {
        case 2097157:
          ret = {
            Icon: Protocol.MarkerIcon[11],
            CustomFilterType: "1",
          };
          break;
        case 2097156:
          ret = {
            Icon: Protocol.MarkerIcon[6],
            CustomFilterType: "2",
          };
          break;
      }
      return ret;
    },
  },
};
</script>


 